<form [formGroup]="partsManagementSearchTextForm">
  <div>
    <mc-input
      hiddenlabel
      placeholder="Search for a part"
      fit="small"
      ngDefaultControl
      formControlName="searchText"
      (keyup.enter)="applySearchTextFilters()"
      icon="magnifying-glass"
      [clearbutton]="true"
      (clearbuttonclick)="applySearchTextFilters()"
      [attr.invalid]="isControlInErrorState(this.partsManagementSearchTextForm.controls.searchText)">
      @if (this.partsManagementSearchTextForm.controls.searchText.hasError('pattern')) {
        <span slot="errormessage">Incorrect parts code</span>
      }
    </mc-input>
  </div>
</form>
